export default __webpack_public_path__ + "120f0fc581312fea9ae9aceaeaafffb4.jpg";